module.exports = __webpack_public_path__ + "img/proses_bag.36ea177d.svg";